
<template>

	<mymodal ref="modal" title="Удалить фильтр" ok="Удалить" :reset="reset" :submit="submit" drag_only_head :vheight="0.5">

		<b-form-input v-model="name" v-on:input="name => search(name)" placeholder="Поиск"/>

		<b-form-checkbox
			v-model="someSelected"
			:indeterminate="indeterminate"
			aria-describedby="attrs"
			aria-controls="attrs"
			@change="toggleAll"
		>
			Выбрать все
		</b-form-checkbox>

		<b-form-checkbox-group class="mt-2 main-container_content" stacked :options="filters_visible" v-model="selected"/>

	</mymodal>

</template>

<script>

import api from "../../api"
import mymodal from "../widgets/modal"

export default
{
	props :
	{
		essence : String,
	},

	components :
	{
		mymodal
	},

	data()
	{
		return {
			
			filters : [],
			filters_visible : [],
			name : null,
			selected : [],
			state : null,
			someSelected: true,
			indeterminate: false

		}
	},

	watch: 
	{
		selected()
		{
			this.checkbox_state()
		},

		filters_visible()
		{
			this.checkbox_state()
		}
	},

	methods :
	{
		toggleAll(checked)
		{
			checked ? this.check_all() : this.clear_checked()
		},

		get_filters_visible_set()
		{
			return new Set(this.filters_visible.map((filter) => filter.value))
		},

		get_selected_set()
		{
			return new Set(this.selected)
		},

		check_all()
		{
			this.selected = Array.from(this.get_selected_set().union(this.get_filters_visible_set()))
		},

		clear_checked()
		{
			this.selected = Array.from(this.get_selected_set().difference(this.get_filters_visible_set()))
		},

		checkbox_state()
		{
			const filters_visible_set = this.get_filters_visible_set()
			const selected_visible_set = this.get_selected_set().intersection(filters_visible_set)

			if (selected_visible_set.size === 0)
			{
				this.indeterminate = false
				this.someSelected = false
			} 
			else if (selected_visible_set.size >= filters_visible_set.size)
			{
				this.indeterminate = false
				this.someSelected = true
			} 
			else
			{
				this.indeterminate = true
				this.someSelected = true
			}
		},

		reset()
		{
			this.selected = []
			this.name = null
			this.state = null
			this.someSelected = true
			this.indeterminate = false
		},

		execute()
		{
			this.filters = []

			var query

			if(this.essence == "cadastral_objects" || this.essence == "cadastral_analogues")
				query = { "$or" : [ { essence : "cadastral_objects" }, { essence : "cadastral_analogues" } ] }
			else
				query = { essence : this.essence }

			var not_editable_date = Date.parse("2024-01-14") //TODO
			api.call(this, "filters", "get_many", { query : query },
				response =>
				{
					var filters = []

					response.data.forEach(filter => filters.push({ text : filter.name, value : filter.id,
						disabled : this.$root.not_editable && (not_editable_date >= Date.parse(filter.add_date))
					}))

					this.filters = filters
					this.filters_visible = filters
				})

			this.$refs.modal.execute()
		},

		check()
		{
			this.state = ( this.selected == null )

			return this.state
		},

		submit()
		{
			this.$emit("delete", this.filters.filter((filter) => this.selected.includes(filter.value)))
		},

		search(name)
		{
			if(name == null)
				name = this.name

			const exp = new RegExp(name, "i")

			this.filters_visible = this.filters.filter(elem =>
				( elem.text.match(exp) || name == null )
			)
		},
	}
}

</script>

<style scoped>
* >>> option:disabled
{
	background-color: #f8f8f8;
}
</style>